import {
  Dic
} from '@src/common/utils'
import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
const tableOption = function (workshopShow) {
  if (workshopShow) {
    return {
      add: '新增',
      edit: '修改',
      view: '查看',
      page: true,
      selection: false,
      index: false,
      indexLabel: '序号',
      refreshBtn: false,
      columnBtn: false,
      stripe: true,
      addBtn: false,
      editBtn: false,
      delBtn: false,
      viewFormSlot: true,
      labelSuffix: '：',
      size: 'small',
      maxHeight: '100%',
      labelWidth: '0px',
      menuAlign: 'center',
      searchMenuSpan: 6,
      searchBtn: false,
      dialogHeight: 350,
      dialogWidth: '700px',
      emptyText: i18n.t('personAccess.title.noData'),
      menu: false,
      column: [{
          label: '姓名',
          prop: 'name',
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          overHidden: true,
          search: false,
          searchPlaceholder: '请输入姓名',
          span: 12,
        },
        {
          label: '电话',
          prop: 'phone',
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          overHidden: true,
          search: false,
          span: 12,
        },
        {
          label: '工号',
          prop: 'workNo',
          search: false,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          span: 12,
        },
        {
          label: '岗位',
          prop: 'position',
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          overHidden: true,
          search: false,
          searchPlaceholder: '请选择',
          span: 12,
        },
        {
          label: '', //保卫账户列表
          prop: 'groupType',
          span: 24,
          searchSlot: true,
          hide: true,
          search: false,
        }
      ]
    }
  } else {
    return {
      add: '新增',
      edit: '修改',
      view: '查看',
      page: true,
      selection: true,
      index: false,
      indexLabel: '序号',
      refreshBtn: false,
      columnBtn: false,
      stripe: true,
      addBtn: false,
      editBtn: false,
      delBtn: false,
      viewFormSlot: true,
      labelSuffix: '：',
      size: 'small',
      maxHeight: '100%',
      labelWidth: '0px',
      menuAlign: 'center',
      searchMenuSpan: 6,
      searchBtn: false,
      dialogHeight: 350,
      dialogWidth: '700px',
      emptyText: i18n.t('personAccess.title.noData'),
      menu: false,
      column: [{
          label: '姓名',
          prop: 'name',
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          overHidden: true,
          search: false,
          searchPlaceholder: '请输入姓名',
          span: 12,
        },
        {
          label: '电话',
          prop: 'phone',
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          overHidden: true,
          search: false,
          span: 12,
        },
        {
          label: '人员类型',
          prop: 'personOrAccountType',
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          overHidden: true,
          search: false,
          searchPlaceholder: '请选择',
          span: 12,
          viewFormatter: (row, value) => {
            if (Number(value) === 1) {
              return '保卫'
            } else if (Number(value) === 2) {
              return '员工'
            }
            return '';
          },
          formatter: (row, value) => {
            if (Number(value) === 1) {
              return '保卫'
            } else if (Number(value) === 2) {
              return '员工'
            }
            return '';
          },
          dicData: [{
              label: '保卫',
              value: '1'
            },
            {
              label: '员工',
              value: '2'
            }
          ],
        },
        {
          label: '', //保卫账户列表
          prop: 'groupType',
          span: 24,
          searchSlot: true,
          hide: true,
          search: true,
        }
      ]
    }
  }
}
export default tableOption